import PropTypes from 'prop-types';

const LoadFromBackendMenuItem = ({ getComponent, onClick, children = null }) => {
  const DropdownMenuItem = getComponent('DropdownMenuItem');

  return <DropdownMenuItem onClick={onClick}>{children || 'Load from Server'}</DropdownMenuItem>;
};

LoadFromBackendMenuItem.propTypes = {
  getComponent: PropTypes.func.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

export default LoadFromBackendMenuItem;
